import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { TableRow } from "../../components/table-components/TableRow";
import { AdminUserListItem } from "../../service/api-response/AdminUsersSuccessResponse";

interface AdminUserListRowProps {
  href: string;
  user: AdminUserListItem;
}

export const AdminUserListRow = ({ href, user }: AdminUserListRowProps) => {
  return (
    <TableRow>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {user.username}
        </StyledText>
      </TableCellLink>
    </TableRow>
  );
};
